import React, { useEffect, useState, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ThemeProvider } from '@mui/material';
import { theme } from './scss/theme';
import { orderTemplate } from './util/order';
import Header from './components/Header';
import Loader from './components/Loader';

// Lazy load components for better code splitting
const Layout = React.lazy(() => import('./pages/Layout'));
const Welcome = React.lazy(() => import('./pages/Welcome'));
const Error = React.lazy(() => import('./pages/Error'));

// Lazy load flow-specific components that include their own contexts
const BrandFlow = React.lazy(() => import('./flows/BrandFlow'));
const EventFlow = React.lazy(() => import('./flows/EventFlow'));

function getCachedOrder() {
  const cached = window.sessionStorage.getItem('order');
  if (typeof cached === 'string') {
    return JSON.parse(cached);
  }
  return { ...orderTemplate };
}

function App() {
  const [order, setOrder] = useState(getCachedOrder());
  const location = useLocation();

  useEffect(() => {
    window.sessionStorage.setItem('order', JSON.stringify(order));
  }, [order]);

  return (
    <div className="app">
      <AnimatePresence initial={false} mode="wait">
        <ThemeProvider theme={theme}>
          <Suspense fallback={<div className="flex-row" style={{ width: '100%', height: '100vh', justifyContent: 'center', alignItems: 'center' }}><Loader /></div>}>
            <Routes location={location}>
              <Route path="/" element={<Layout header={<Header />} />}>
                <Route path="/" element={<Welcome />} />
                {/* Brand flow with its own context */}
                <Route path="brandscent/*" element={<BrandFlow />} />
                {/* Event flow with its own context */}
                <Route
                  path="event/*"
                  element={
                    <EventFlow
                      setOrder={setOrder}
                    />
                  }
                />
              </Route>
              <Route path="error" element={<Error />} />
              <Route path="*" element={<Error />} />
            </Routes>
          </Suspense>
        </ThemeProvider>
      </AnimatePresence>
    </div>
  );
}

export default App;
